import React from "react";
import get from "lodash/get";
import { useQuery, useMutation } from "services/Client";
import { useNavigate, useParams } from "react-router-dom";
import withNotification from "services/Notification";

import removeData from "shared/helpers/removeData";

import List from "./View";
function AllActivities({ notification }) {
  const { lessonId } = useParams();

  const { data } = useQuery({
    event: "activity.get.many",
    variables: {
      where: { lessonId: { _eq: lessonId } },
    },
  });

  const dataList = get(data, "activity", [])
    .slice(0)
    .sort((a, b) => a.order - b.order);

  const { mutate: deleteTest } = useMutation({
    event: "activity.delete",
    update: ({ data: newData }) => {
      const newData1 = removeData(data, newData.deleteActivity);
      return {
        event: "activity.get.many",
        variables: {
          where: { lessonId: { _eq: lessonId } },
        },
        data: newData1,
      };
    },
  });
  let navigate = useNavigate();

  const removeTest = async (mutate, id) => {
    mutate({ variables: { where: { id } } })
      .then((res) => {
        if (get(res, "data.deleteSection.id")) {
          notification.success("Delete Successful");
        } else {
          notification.error("Error");
        }
      })
      .catch((e) => {});
  };

  return (
    <List
      data={dataList}
      handleCreate={() => navigate("new")}
      handleDelete={(id) => removeTest(deleteTest, id)}
    />
  );
}

export default withNotification(AllActivities);
